import React, { useEffect, useState } from 'react';

import { Alert, Button, Col, Form, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import BtnSliderRoundedComponent from '../switch/BtnSliderRoundedComponent';
import { conditionalSuccess, determineDefault, isValid } from './FormUtils';
import { Actions } from '../../../client/Actions';
import ModalForm from './ModalForm';
import FormInputFile from '../file/FormInputFile';
import renderUtils from '../../helpers/renderUtils';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Typeahead } from 'react-bootstrap-typeahead';
import XButton from '../button/XButton';
import { isObject } from 'formik';
import { CustomSelect } from './CustomSelect';
import CardTable from '../table/CardTable';
import { NumericFormat } from 'react-number-format';
import Select from 'react-select';
import utils from '../../helpers/utils';
import NcInputNumber from './NcInputNumber';
import CheckGroup from './CheckGroup';
import FunctionalTableField from './FunctionalTableField';
import 'react-datepicker/dist/react-datepicker.css';
import DatePickerField from './simpleFields/DatePickerField';
import DateRangePickerField from './simpleFields/DateRangePickerField';
import RadioGroupGeneric from './radioGroup/RadioGroupGeneric';
import EditableSection from './EditableSection';
import DivBetween from '../div/DivBetween';
import TrickButton from '../button/TrickButton';
import 'react-phone-input-2/lib/bootstrap.css';
import PhoneInput from 'react-phone-input-2';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const FormGenerator = ({
                         fields,
                         initialData,
                         formData,
                         setFormData,
                         setReady,
                         initData,
                         readOnly,
                         alertInvalid,
                         localDictionaries,
                         reload,
                         alertData,
                         additionalDataForFilters,
                         hideIfNull,
                         onRemoveField,
                         setLoader,
                         editMode,
                         onSubmit
                       }) => {

  if(!fields){
    return <>Brak konfiguracji</>
  }

  const [dictionaries, setDictionaries] = useState({});
  const tempState = {};

  const [errors, setErrors] = useState({});
  const [validation, setValidation] = useState([]);
  const [showMeasurement, setShowMeasurement] = useState({});
  const [creationModals, setCreationModals] = useState({});
  const [tableChecked, setTableChecked] = useState();
  const [dictionaryDetailsExpanded, setDictionaryDetailsExpanded] = useState(
    {}
  );

  const booleanOptions = [
    { id: true, name: 'Tak' },
    { id: false, name: 'Nie' }
  ];

  function loadDictionaries() {
    const required = new Set();

    fields.fields.forEach((field) => {
      const { type, dictionary, dictionaryApi, enumType, readOnlyValue } = field;

      if (readOnly === true && !readOnlyValue) return;

      if (
        type === 'dictionary' ||
        type?.toLowerCase() === 'imageradio' ||
        type?.toLowerCase() === 'checkgroup' ||
        type?.toLowerCase() === 'radiogroupdictionary'
      ) {
        if (dictionary) {
          required.add(dictionary);
        }
      }

      if (type === 'enum' && enumType) {
        required.add(enumType);
      }
    });

    const promises = [];

    required.forEach((key) => {
      if (localDictionaries && localDictionaries[key]) {
        tempState[key] = localDictionaries[key];
      } else {
        const field = fields.fields.find(
          (f) => f.dictionary === key || f.enumType === key
        );
        const url = field?.dictionaryApi || key;

        promises.push(
          new Promise((resolve) => {
            Actions.get(url, (data) => {
              tempState[key] = data;
              resolve();
            });
          })
        );
      }
    });

    if (promises.length === 0) {
      setDictionaries(tempState);
      return;
    }

    Promise.all(promises).then(() => {
      setDictionaries(tempState);

      // optionally set default values
      Object.keys(tempState).forEach((key) => {
        if (
          Array.isArray(tempState[key]) &&
          tempState[key].some((v) => v.defaultValue || v.defaultValue === 'true')
        ) {
          const defaultValue = tempState[key].find(
            (v) => v.defaultValue || v.defaultValue === 'true'
          );
          handleFieldChange(key, defaultValue);
        }
      });
    });
  }





  function reloadData() {
    loadDictionaries();
  }

  function formAction() {
    if (formData && readOnly !== true) {
      validate();
      console.log(formData);
    } else if (initData !== false) {
      initFormData();
    }
  }

  function validate() {
    let validationResult = [];
    let allValid = true;
    fields.fields
      .filter((f) => f.type !== 'unvisible')
      .filter((f) => f.type !== 'staticImage'.toLowerCase())
      .filter((f) => f.type !== 'component')
      .filter((f) => f.onlyForReadOnly !== true)
      .forEach((field) => {
        let valid = isValid(field, formData);
        let fieldErrors = errors[field.name];

        validationResult[field.name] = valid && !fieldErrors;
        if (!validationResult[field.name]) {
          allValid = false;
        }
      });

    setValidation(validationResult);

    setReady(allValid);
  }

  function initFormData() {
    if (!formData ) {
      const result = {};
      console.log("fields ", fields)
      fields.fields
        .filter((f) => (readOnly ? true : f.onlyForReadOnly !== true))
        .forEach((field) => {
          if (field.type === 'dateRange') {
            result[field.startField] = determineDefault(
              {
                name: field.startField
              },
              initialData,
              dictionaries
            );
            result[field.endField] = determineDefault(
              {
                name: field.endField
              },
              initialData,
              dictionaries
            );
          } else {
            result[field.name] = determineDefault(
              field,
              initialData,
              dictionaries
            );
          }
        });
      setFormData(result);
    }
  }

  function initChecked() {
    const tableField = fields.fields.find((f) => f.type === 'table');

    if (tableField && !tableChecked && formData) {
      setTableChecked(formData[tableField.name]);
    }
  }

  function handleTableCheckedChanged() {
    const tableField = fields.fields.find((f) => f.type === 'table');

    if (tableField && tableChecked && formData) {
      handleMultipleFieldsChange(tableField.name, tableChecked);
    }
  }

  useEffect(formAction, [formData, readOnly, errors]);
  useEffect(reloadData, [reload, localDictionaries]);
  useEffect(loadDictionaries, [readOnly]);
  useEffect(initChecked, [formData]);
  useEffect(handleTableCheckedChanged, [tableChecked]);

  const handleFieldChange = (
    fieldName1,
    value1,
    fieldName2 = null,
    value2 = null
  ) => {
    setFormData((prev) => ({
      ...prev,
      uuid: Math.floor(Math.random() * 101010),
      [fieldName1]: value1,
      ...(fieldName2 ? { [fieldName2]: value2 } : {})
    }));
  };

  const handleModalChange = (fieldName, value) => {
    setCreationModals({
      ...creationModals,
      [fieldName]: value
    });
  };

  const collapseDictionary = (fieldName) => {
    setDictionaryDetailsExpanded({
      ...dictionaryDetailsExpanded,
      [fieldName]: !dictionaryDetailsExpanded[fieldName]
    });
  };

  function fetchValueFromDictionary(triggerValue, triggerField) {
    if (triggerValue) {
      let triggerFieldDef = fields.fields.find((f) => f.name === triggerField);
      if (
        triggerFieldDef &&
        triggerFieldDef.type === 'dictionary' &&
        dictionaries[triggerFieldDef.dictionary]
      ) {
        triggerValue = dictionaries[triggerFieldDef.dictionary].find(
          (d) => d.id == triggerValue.id
        );
      }
    }
    return triggerValue;
  }

  function fillFieldsToUpdate(fieldName, updated, result) {
    const filtered = fields.fields.filter(
      (f) =>
        !updated.includes(f.name) &&
        f.autoComplete &&
        f.autoComplete.triggers &&
        f.autoComplete.triggers.includes(fieldName)
    );

    filtered.forEach((f) => {
      const index = f.autoComplete.triggers.indexOf(fieldName);
      let calculated;

      if (f.autoComplete.triggers.length === 1) {
        const triggerField = f.autoComplete.triggers[0];

        let triggerValue = result[triggerField]
          ? result[triggerField]
          : formData[triggerField];
        triggerValue = fetchValueFromDictionary(triggerValue, triggerField);

        calculated = f.autoComplete.calculation(triggerValue);
      } else if (index === 0) {
        const secondField = f.autoComplete.triggers[1];
        const secondValue = result[secondField]
          ? result[secondField]
          : formData[secondField];
        calculated = f.autoComplete.calculation(result[fieldName], secondValue);
      } else {
        const firstField = f.autoComplete.triggers[0];
        const firstValue = result[firstField]
          ? result[firstField]
          : formData[firstField];
        calculated = f.autoComplete.calculation(firstValue, result[fieldName]);
      }
      result[f.name] = calculated;

      if (result[f.name] !== calculated) {
        result[f.name] = calculated;
        updated.push(f.name);
      }
    });

    filtered.forEach((f) => {
      fillFieldsToUpdate(f.name, updated, result);
    });

    const conditional = fields.fields.filter(
      (f) =>
        !updated.includes(f.name) &&
        f.conditionalOn &&
        f.conditionalOn === fieldName &&
        !conditionalSuccess(
          fields.fields.find((ff) => f.name === ff.name),
          result
        )
    );

    conditional.forEach((f) => {
      if (f.preserveOnHide) {
        return;
      }

      result[f.name] = determineDefault(f, initialData, dictionaries);

      updated.push(f.name);

      fillFieldsToUpdate(f.name, updated, result);
    });

    const clearAfterChange = fields.fields.filter(
      (f) => !updated.includes(f.name) && f.clearAfterChange === fieldName
    );

    clearAfterChange.forEach((f) => {
      result[f.name] = determineDefault(f, initialData, dictionaries);

      updated.push(f.name);
    });
  }

  const handleMultipleFieldsChange = (fieldName, value) => {
    const updateFileds = [fieldName];
    const result = { [fieldName]: value };
    fillFieldsToUpdate(fieldName, updateFileds, result);

    setFormData({
      ...formData,
      ...result,
      uuid: Math.floor(Math.random() * 101010)
    });
  };

  function defineClass(field) {
    if (calculateReadOnly(field)) {
      return '';
    }
    // return validation[field.name] ? "is-valid" : "is-invalid";
    return `rounded ${validation[field.name] ? '' : ''}`;
  }

  function calculateReadOnly(field) {
    return (
      field.readOnly ||
      readOnly ||
      (editMode && fields.config.editOnlyExplicitlyIncluded
        ? !field.editable
        : field.editable === false)
    );
  }

  function textField(field, value) {
    const val = value || formData[field.name];

    if (hideIfNull && (val === '' || !val)) {
      return '';
    }

    return (
      <>
        {field.alert &&
          field.alert.condition(value || formData[field.name], alertData) && (
            <Alert variant="danger">
              <i className="fas fa-info-circle me-1"></i>
              <strong> {field.alert.title}</strong>
            </Alert>
          )}
        <Form.Group
          className={'form-group ' + (field.hideOnPrint ? 'print-hide' : '')}
        >
          <Form.Label>
            {field.label}
            {field.infoIcon && (
              <OverlayTrigger
                overlay={<Popover id="popover-basic">{field.infoIcon}</Popover>}
                placement="left"
                delay={{ show: 24 }}
              >
                <div className="text-secondary">
                  <i
                    className="fas fa-info-circle"
                    style={{
                      marginLeft: '5px',
                      fontSize: '15px',
                      color: '#ff5205'
                    }}
                  />
                </div>
              </OverlayTrigger>
            )}
          </Form.Label>
          <Row>
            <Col md={field.removable ? 9 : 12}>
              {field.type !== 'number' && field.type !== 'phone-number' && (
                <>
                  <Form.Control
                    isInvalid={!!errors[field.name]}
                    maxLength={field.maxLength}
                    as={field.type === 'textarea' ? field.type : 'input'}
                    className={defineClass(field)}
                    rows={
                      field.type === 'textarea' ? field.rows || 5 : undefined
                    }
                    disabled={calculateReadOnly(field)}
                    id={field.name}

                    onBlur={(event) => {
                      const newValue = event.target.value;

                      if (field.type === 'email') {
                        if (newValue === '') {
                          setErrors((prev) => ({ ...prev, [field.name]: null }));
                          handleMultipleFieldsChange(field.name, null);
                        } else {
                          if (!emailRegex.test(newValue)) {
                            setErrors((prev) => ({
                              ...prev,
                              [field.name]: 'Nieprawidłowy email'
                            }));
                          } else {
                            setErrors((prev) => ({ ...prev, [field.name]: null }));
                          }
                        }
                      }


                    }}

                    onChange={(event) => {
                      let newValue = event.target.value;
                      if (field.type === 'decimal' && newValue !== '') {
                        newValue = parseFloat(parseFloat(newValue).toFixed(2));
                      }

                      if (field.format && newValue !== '') {
                        newValue = field.format(newValue);
                      }

                      if (field.capsLock && newValue !== '') {
                        newValue = newValue.toUpperCase();
                      }

                      if (field.type === 'email') {
                        if (newValue === '') {
                          setErrors((prev) => ({ ...prev, [field.name]: null }));
                        } else {
                          if (emailRegex.test(newValue)) {
                            setErrors((prev) => ({ ...prev, [field.name]: null }));
                          }
                        }
                      }

                      if (
                        field.maxLength &&
                        newValue &&
                        newValue.length > field.maxLength
                      ) {
                        return;
                      }

                      handleMultipleFieldsChange(field.name, newValue);
                    }}
                    name={field.name}
                    value={value || formData[field.name]}
                    type="text"
                    placeholder={field.placeholder}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors[field.name]}
                  </Form.Control.Feedback>
                  {field.maxLength ? (
                    <>
                      {field.maxLength > 0 ? (
                        <Form.Text className="text-muted">
                          {(value || formData[field.name])?.length || 0}/
                          {field.maxLength} symboli
                        </Form.Text>
                      ) : (
                        <Form.Text className="text-muted">
                          Osiągnieto maksymalną ilość symboli
                        </Form.Text>
                      )}
                    </>
                  ) : (
                    ''
                  )}
                </>
              )}
              {field.type === 'number' && (
                <NumericFormat
                  id={field.name}
                  disabled={calculateReadOnly(field)}
                  className={'form-control ' + defineClass(field)}
                  onValueChange={(values) => {
                    handleMultipleFieldsChange(
                      field.name,
                      field.nullOnEmpty && values.value === ''
                        ? null
                        : values.value
                    );
                  }}
                  name={field.name}
                  isAllowed={(values) => {
                    const { floatValue } = values;
                    return (
                      !field.maxValue ||
                      floatValue === undefined ||
                      floatValue <= field.maxValue
                    );
                  }}
                  allowNegative={false}
                  fixedDecimalScale={field.fixedDecimalScale}
                  decimalScale={field.scale}
                  suffix={field.suffix}
                  thousandSeparator=" "
                  value={value ?? formData[field.name] ?? ''}
                  placeholder={field.placeholder}
                />
              )}
              {field.type === 'phone-number' && (
                <PhoneInput
                  country={'pl'}
                  prefix={'+'}
                  disabled={calculateReadOnly(field)}
                  countryCodeEditable={false}
                  value={value || formData[field.name]}
                  onChange={(value, data, event, formattedValue) => {
                    handleMultipleFieldsChange(field.name, value);
                  }}
                  inputProps={{
                    name: field.name,
                    id: field.name,
                    disabled: calculateReadOnly(field),
                    placeholder: field.placeholder,
                    className: 'form-control ' + defineClass(field)
                  }}
                />
              )}
            </Col>
            {field.removable && (
              <Col md={3} className={'ms-0 pl-0'}>
                <XButton
                  tooltip={field.removableTooltip}
                  onClick={() => onRemoveField(field)}
                />
              </Col>
            )}
          </Row>
        </Form.Group>
      </>
    );
  }

  function counter(field) {
    return (
      <>
        <NcInputNumber
          id={field.name}
          disabled={calculateReadOnly(field)}
          className={defineClass(field)}
          label={field.label}
          defaultValue={formData[field.name] || field.defaultValue}
          onChange={(newValue) => {
            handleMultipleFieldsChange(field.name, newValue);
          }}
        />
        <hr />
      </>
    );
  }

  // function datePicker(field) {
  //
  //
  //     return (
  //         <>
  //             <Form.Group  className={"form-group " + (field.hideOnPrint ? "print-hide" : "")}>
  //                 <Form.Label>{field.label}</Form.Label>
  //                 <Form.Control
  //                     className={defineClass(field)}
  //                     disabled={calculateReadOnly(field)}
  //                     id={field.name}
  //
  //                     onChange={(event) => {
  //                         let newValue = event.target.value;
  //                         handleFieldChange(field.name, newValue);
  //                     }}
  //                     name={field.name}
  //                     value={formData[field.name]}
  //                     type="date"
  //                 />
  //             </Form.Group>
  //         </>
  //     );
  //
  //
  // }

  function timePicker(field) {
    return (
      <Form.Group
        className={'form-group ' + (field.hideOnPrint ? 'print-hide' : '')}
      >
        <Form.Label>{field.label}</Form.Label>
        <Form.Control
          className={defineClass(field)}
          disabled={calculateReadOnly(field)}
          id={field.name}
          name={field.name}
          type="time"
          value={formData[field.name] || ''}
          onChange={(event) => {
            handleFieldChange(field.name, event.target.value);
          }}
        />
      </Form.Group>
    );
  }

  function datePicker(field) {
    return (
      <DatePickerField
        field={field}
        formData={formData}
        handleFieldChange={handleFieldChange}
        defineClass={defineClass}
        calculateReadOnly={calculateReadOnly}
      />
    );
  }

  function dateRange(field) {
    return (
      <DateRangePickerField
        field={field}
        formData={formData}
        handleFieldChange={handleFieldChange}
        defineClass={defineClass}
        calculateReadOnly={calculateReadOnly}
        fromLabel={field.fromLabel}
        toLabel={field.toLabel}
      />
    );
  }

  function file(field) {
    return (
      <>
        <FormInputFile
          key={formData[field.name]}
          titleText={field.label}
          labelText={'Wybierz plik'}
          idName={field.name}
          formats={field.fileFormats}
          single={field.single}
          path={field.fileApi || ('file/' + (field.privateView ? 'private' : 'public'))}
          fileNameField={field.fileNameField || 'fileName'}
          filePathField={field.filePathField || 'filePath'}
          requestParameterName={field.requestParameterName || 'file'}
          setImagesParentStore={(files) => {
            handleFieldChange(field.name, field.single ? files[0] : files);
          }}
          imagesParentStore={
            field.single
              ? formData[field.name]
                ? [formData[field.name]]
                : []
              : formData[field.name]
          }
          disabled={calculateReadOnly(field)}
        />
      </>
    );
  }

  function boolean(field) {
    if (readOnly) {
      const bool = booleanOptions.find((v) => v.id === formData[field.name]);
      const value = bool ? bool.name : '';

      return textField(field, value);
    }

    return (
      <>
        <Form.Group className="form-group">
          <Form.Label>{field.label}</Form.Label>
          <Form.Select
            name={field.name}
            if={field.name}
            value={formData[field.name]}
            disabled={calculateReadOnly(field)}
            className={defineClass(field)}
            onChange={(event) => {
              let newValue = JSON.parse(event.target.value);

              handleMultipleFieldsChange(field.name, newValue);
            }}
          >
            <option value="" disabled={!field.defaultEnabled}>
              Wybierz...
            </option>
            {booleanOptions.map((el) => {
              return (
                <option key={el.id} value={el.id}>
                  {el.name}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
      </>
    );
  }

  function renderDictionaryName(field, dictionaryValue) {
    return field.render ? field.render(dictionaryValue) : dictionaryValue.name;
  }

  function dictionary(field) {
    const { dictionaryApi, dictionary, groupedDictionary } = field;
    let values = dictionaries[dictionary] || [];

    if (readOnly) {
      const dictionaryValue = formData[field.name];
      let value = dictionaryValue
        ? renderDictionaryName(field, dictionaryValue)
        : '';
      if (!value || value === '') {
        if (field.readOnlyValue) {
          value = field.readOnlyValue(values);
        }
      }
      return textField(field, value ? value : '');
    }

    if (field.filterValues) {
      values = field.filterValues(
        dictionaries,
        formData,
        values,
        additionalDataForFilters
      );
    }

    const selectOptions = fields.useSelect
      ? values.map((v) => {
        return { value: v, label: field.renderOption(v) };
      })
      : [];



    return (
      <>
        <Form.Group
          className="form-group">
          <Form.Label>{field.label}</Form.Label>
          {field.creationForm ? (
            <div
              className="text-secondary"
              id={'open-modal' + field.name}
              onClick={() => handleModalChange(field.name, true)}
            >
              <i
                className="fas fa-plus-circle"
                style={{ marginLeft: '5px', fontSize: '15px' }}
              />
            </div>
          ) : (
            ''
          )}
          {field.withAutocomplete && (
            <Typeahead
              name={field.name}
              id={field.name}
              labelKey={field.labelKey || 'presentableName'}
              disabled={calculateReadOnly(field)}
              options={values}
              filterBy={field.filterBy}
              placeholder={field.placeholder}
              // selected={formData[field.name] ? formData[field.name] : null}
              className={defineClass(field)}
              renderMenuItemChildren={(option) => (
                <div>
                  {field.renderOption
                    ? field.renderOption(option)
                    : option.id + ''}
                </div>
              )}
              onChange={(value) =>
                handleMultipleFieldsChange(field.name, value[0])
              }
            />
          )}
          {field.useSelect && (
            <>
              <CustomSelect
                value={selectOptions.find(
                  (o) => o.value.id === formData[field.name]?.id
                )}
                onChange={(selectedOption) =>
                  handleMultipleFieldsChange(field.name, selectedOption.value)
                }
                classNamePrefix={defineClass(field) + ' ' + field.className}
                placeholder={field.placeholder || 'Wybierz...'}
                searchBy={field.searchBy}
                options={values.map((v) => {
                  return {
                    value: v,
                    isDisabled: field.optionDisabled
                      ? field.optionDisabled(v)
                      : false,
                    label: field.renderOption(v)
                  };
                })}
              />
            </>
          )}
          {!field.withAutocomplete && !field.useSelect && (
            <Form.Select
              name={field.name}
              id={field.name}
              disabled={calculateReadOnly(field)}
              value={formData[field.name] ? formData[field.name].id : ''}
              className={defineClass(field)}
              onChange={(event) => {
                if (field.selectObject) {
                  handleMultipleFieldsChange(
                    field.name,
                    values.find((v) => v.id === parseInt(event.target.value))
                  );
                } else {
                  handleMultipleFieldsChange(field.name, {
                    id: parseInt(event.target.value)
                  });
                }
              }}
            >
              <option value="" disabled>
                Wybierz...
              </option>
              {groupedDictionary
                ? Object.keys(values).map((item, i) => (
                  <>
                    <optgroup key={item + i} label={item}>
                      {values[item].map((item, index) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </optgroup>
                  </>
                ))
                : values.map((val) => {
                  return (
                    <option key={val.id} value={val.id}>
                      {renderDictionaryName(field, val)}
                    </option>
                  );
                })}
            </Form.Select>
          )}
        </Form.Group>

        {field.creationForm ? (
          <ModalForm
            setLoader={() => {
            }}
            api={dictionaryApi ? dictionaryApi : dictionary}
            title={field.modalTitle ? field.modalTitle : 'Nowy ' + field.label}
            open={creationModals[field.name]}
            setOpen={(value) => handleModalChange(field.name, value)}
            fields={field.creationForm}
            size={'md'}
            onFinish={reloadData}
          />
        ) : (
          ''
        )}
      </>
    );
  }

  function multipleEnumType(field, values, enumType) {
    return (
      <Form.Group className="form-group">
        <Form.Label>{field.label}</Form.Label>
        <Select
          value={formData[field.name] ? formData[field.name].id : ''}
          onChange={(selectedOption) =>
            handleFieldChange(
              field.name,
              selectedOption.length > 0
                ? selectedOption.map((sv) => sv.value)
                : undefined
            )
          }
          classNamePrefix={defineClass(field)}
          isMulti
          placeholder={'Wybierz...'}
          options={values.map((v) => {
            return { value: v, label: renderUtils.renderEnumName(v, enumType) };
          })}
        />
      </Form.Group>
    );
  }

  function staticImage(field) {
    function determineSrc() {
      let src;
      if (field.imageFrom) {
        const formDataField = formData[field.imageFrom];
        if (formDataField) {
          if (field.imageFieldDictionaryName) {
            src = formDataField[field.imageFieldName];
          } else {
            src = formDataField[field.imageFieldName];
          }
        }
      } else if (field.fileName) {
        src = `/assets/img/${field.fileName}`;
      }
      if (src && field.fromApi) {
        src = utils.defaultUrl() + src;
      }

      return src;
    }

    let src = determineSrc();

    return (
      <div>
        {field.label && <Form.Label>{field.label}</Form.Label>}
        {formData && src && (
          <img
            className={'mt-2'}
            src={determineSrc()}
            alt={field.label}
            style={{ maxWidth: '100%' }}
          />
        )}
      </div>
    );
  }

  function enumType(field) {
    const { enumType } = field;
    let values = dictionaries[enumType] || [];

    if (field.filterValues) {
      values = field.filterValues(
        dictionaries,
        formData,
        values,
        additionalDataForFilters
      );
    }

    if (readOnly) {
      const enumValue = formData[field.name];
      if (field.multiple) {
        const value =
          enumValue && Array.isArray(enumValue)
            ? enumValue
              .map((v) => renderUtils.renderEnumName(v, enumType))
              .join(', ')
            : '';
        return textField(field, value ? value : '');
      }

      const value = enumValue
        ? renderUtils.renderEnumName(enumValue, enumType)
        : '';
      return textField(field, value ? value : '');
    }

    if (field.multiple) {
      return multipleEnumType(field, values, enumType);
    }

    return (
      <>
        <Form.Group className="form-group">
          <Form.Label>{field.label}</Form.Label>
          <Form.Select
            name={field.name}
            id={field.name}
            disabled={calculateReadOnly(field)}
            value={formData[field.name] ? formData[field.name] : ''}
            className={defineClass(field)}
            onChange={(event) =>
              handleMultipleFieldsChange(field.name, event.target.value)
            }
          >
            <option value="" disabled>
              Wybierz...
            </option>
            {values.map((value) => {
              return (
                <option key={value} value={value}>
                  {renderUtils.renderEnumName(value, enumType)}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
      </>
    );
  }

  function dictionaryDetails(field) {
    const value = formData[field.name];
    const keys = value ? Object.keys(value) : [];

    return (
      <>
        <Form.Group className="form-group">
          <Form.Label>{field.label}</Form.Label>

          <Row>
            <Col className="d-flex">
              <Form.Control
                name={field.name + '-name'}
                value={value ? value.name : ''}
                readOnly={true}
                type="text"
                placeholder=""
              />
              {keys.length > 2 ? (
                <Button
                  variant="outline-primary"
                  onClick={() => collapseDictionary(field.name)}
                  id={'collapse-' + field.name}
                  data-toggle="collapse"
                  role="button"
                  className="collapsed"
                  type="button"
                  data-target={'#collapse-' + field.name}
                  aria-expanded="false"
                >
                  <i className="fas fa-chevron-down" />
                </Button>
              ) : (
                ''
              )}
            </Col>
          </Row>
        </Form.Group>
      </>
    );
  }

  function radioButton(field) {
    return (
      <>
        <Row className={'justify-content-center'}>
          <Col md={'5'}>
            <strong className={'p-2'}>{field.label}</strong>
          </Col>
          <Col md={'3'}>
            <BtnSliderRoundedComponent
              checked={formData[field.name]}
              setState={() =>
                handleFieldChange(field.name, !formData[field.name])
              }
              disabled={calculateReadOnly(field)}
              red={false}
            />
          </Col>
        </Row>
      </>
    );
  }

  function imageRadio(field) {
    let values = dictionaries[field.dictionary] || [];

    if (readOnly && (!values || values.length === 0) && formData[field.name]) {
      values.push(formData[field.name]);
    }

    return (
      <>
        <Form.Group className="form-group">
          <Form.Label>{field.label}</Form.Label>
          <fieldset>
            <Form.Group className="form-group" as={Row}>
              {values.map((v) => {
                return (
                  <Form.Check
                    key={field.name + '_' + v.id}
                    type="radio"
                    label={
                      <img
                        className={field.imageClassName}
                        alt={field.imageClassName}
                        src={utils.defaultUrl() + v.image}
                      />
                    }
                    name={field.name}
                    onClick={(e) => {
                      if (!calculateReadOnly(field)) {
                        handleMultipleFieldsChange(field.name, v);
                      }
                    }}
                    id={field.name + '_' + v.id}
                    className={
                      field.className +
                      ' ' +
                      (formData[field.name]?.id === v.id
                        ? 'selectedRadioItem'
                        : '')
                    }
                  />
                );
              })}
              {!calculateReadOnly(field) && (
                <Button
                  variant="outline-primary"
                  size="lg"
                  className={'radio-image-button ' + field.otherButtonClassName}
                  onClick={() =>
                    handleMultipleFieldsChange(field.name, { other: true })
                  }
                  type="button"
                >
                  <i className="fas fa-plus" />
                </Button>
              )}
            </Form.Group>
          </fieldset>
        </Form.Group>
      </>
    );
  }

  function checkbox(field) {
    return (
      <>
        <div className={'d-flex'}>
          {field.label}

          <div id={'checkbox-' + field.name} className="">
            <label className="checkbox-container">
              <input
                type="checkbox"
                onChange={() =>
                  handleFieldChange(field.name, !formData[field.name])
                }
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </>
    );
  }

  function functionalTableField(field) {
    return (
      <>
        <FunctionalTableField
          field={field}
          data={formData[field.name]}
          onDataUpdate={(data) => handleMultipleFieldsChange(field.name, data)}
        />
      </>
    );
  }

  function determineField(field) {
    field.type = field.type ? field.type.toLowerCase() : field.type;

    if (!field.processed) {
      field.processed = true;
      if (field.mandatory) {
        field.label = (
          <>
            {field.label} <span className="text-danger"> *</span>
          </>
        );
      }

      if (field.trick) {
        field.label = (
          <DivBetween className={'gap-2'}>
            {field.label} <TrickButton size={10} text={field.trick} />
          </DivBetween>
        );
      }
    }

    if (field.type === 'dictionary') {
      return dictionary(field);
    }

    if (field.type === 'enum') {
      return enumType(field);
    }
    if (field.type === 'staticImage'.toLowerCase()) {
      return staticImage(field);
    }

    if (field.type === 'component') {
      return generateComponent(field);
    }

    if (field.type === 'date') {
      return datePicker(field);
    }

    if (field.type === 'time') {
      return timePicker(field);
    }

    if (field.type === 'dateRange'.toLowerCase()) {
      return dateRange(field);
    }

    if (field.type === 'file') {
      return file(field);
    }

    if (field.type === 'radio') {
      return radioButton(field);
    }
    if (field.type === 'imageRadio'.toLowerCase()) {
      return imageRadio(field);
    }

    if (field.type === 'boolean') {
      return boolean(field);
    }

    if (field.type === 'counter') {
      return counter(field);
    }

    if (field.type === 'checkbox') {
      return checkbox(field);
    }
    if (field.type === 'functionalTableField'.toLowerCase()) {
      return functionalTableField(field);
    }

    if (field.type === 'checkGroup'.toLowerCase()) {
      return (
        <CheckGroup
          field={field}
          formData={formData}
          handleFieldChange={(values) =>
            handleMultipleFieldsChange(field.name, values)
          }
          dictionaries={dictionaries}
        />
      );
    }

    if (field.type === 'radioGroupEnum'.toLowerCase()) {
      return (
        <RadioGroupGeneric
          field={field}
          formData={formData}
          handleFieldChange={(values) =>
            handleMultipleFieldsChange(field.name, values)
          }
          options={field.options}
          isEnum={true}
        />
      );
    }

    if (field.type === 'radioGroupDictionary'.toLowerCase()) {
      return (
        <RadioGroupGeneric
          field={field}
          formData={formData}
          options={dictionaries[field.dictionary]}
          handleFieldChange={(values) =>
            handleMultipleFieldsChange(field.name, values)
          }
        />
      );
    }

    return textField(field);
  }

  function generateComponent(componentField) {
    if (!componentField.name) {
      return 'Define component name!';
    }

    const columns =
      componentField.config && componentField.config.columns
        ? componentField.config.columns
        : 1;

    const blocks = [];

    for (let i = 1; i <= columns; i++) {
      blocks.push(i);
    }

    return (
      <>
        {componentField.title && (
          <>
            <div className={'mt-3'}>
              <h5>{componentField.title}</h5>
            </div>
          </>
        )}

        {blocks.length > 1 ? (
          <Row
            className={componentField.title && 'border-top pt-3'}
            style={{ flexWrap: 'wrap' }}
          >
            {blocks.map((i, idx) => {
              const config = componentField.config || {};
              const columns = config.columns || blocks.length;
              const notStandardSize = config.notStandardSize === true;
              const className = `col-lg-${columns}-part`;

              if (notStandardSize) {
                return (
                  <Col
                    key={idx}
                    xs={12}
                    className={`text-center custom-col ${className}`}
                  >
                    {generateColumn(i, componentField.name)}
                  </Col>
                );
              } else {
                return (
                  <Col
                    key={idx}
                    xs={12}
                    sm={blocks.length > 1 ? 6 : 12}
                    md={12 / blocks.length}
                  >
                    {generateColumn(i, componentField.name)}
                  </Col>
                );
              }
            })}
          </Row>
        ) : (
          generateColumn(1, componentField.name)
        )}
      </>
    );
  }

  const checkColumn = {
    label: 'Wybrano',
    field: 'checked',
    sort: 'desc',
    type: 'checkbox',
    width: 200,
    hideForReadonly: true
  };

  function generateForm() {
    const columns =
      fields.config && fields.config.columns ? fields.config.columns : 1;

    const blocks = [];
    const tableField = fields.fields.find((f) => f.type === 'table');

    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= columns; i++) {
      blocks.push(i);
    }

    return (
      <Form
        noValidate
        onSubmit={onSubmit ? onSubmit : () => {
        }}
        className={`d-grid gap-3 ${alertInvalid ? 'form-invalid-animation' : ''}`}
      >
        {blocks.length > 1 ? (
          <Row>
            {blocks.map((i) => {
              return (
                <Col
                  xs={12}
                  sm={blocks.length > 1 ? 6 : 12}
                  md={12 / blocks.length}
                >
                  {generateColumn(i)}
                </Col>
              );
            })}
          </Row>
        ) : (
          <>{generateColumn(1)}</>
        )}
        {tableField &&
          tableChecked &&
          (tableField.conditionalOn
            ? conditionalSuccess(tableField, formData)
            : true) && (
            <Row>
              <CardTable
                initData={
                  tableField.tableConfig.data
                    ? tableField.tableConfig.data(formData)
                    : undefined
                }
                source={tableField.tableConfig.api}
                setLoader={setLoader}
                shadow={false}
                title={`${tableField.label} (${tableChecked?.length})`}
                checked={tableChecked}
                setChecked={setTableChecked}
                columns={[checkColumn].concat(tableField.tableConfig.columns)}
              />
            </Row>
          )}
      </Form>
    );
  }

  function generateColumn(i, componentName) {
    return fields.fields
      .filter((f) => f.column === i || (!f.column && i === 1))
      .map((field) => {
        if (
          componentName ? componentName !== field.component : field.component
        ) {
          return;
        }

        let show =
          field.type !== 'unvisible' &&
          field.type !== 'table' &&
          (readOnly === true
            ? field.hideForReadOnly !== true
            : field.onlyForReadOnly !== true);

        if (field.conditionalOn && field.type !== 'table') {
          show = conditionalSuccess(field, formData);
        }

        if (show) {
          if (field.wrapWithEditableSection) {
            return (
              <EditableSection
                key={
                  // JSON.stringify(formData?.uuid) +
                  '-editable-section-' +
                  field.name +
                  JSON.stringify(formData[field.name])
                }
                id={'editable-section-' + field.name}
                label={field.label}
                showSummary={formData[field.name] !== undefined}
                summaryContent={
                  field.type === 'boolean'
                    ? (() => {
                      const bool = booleanOptions.find(
                        (v) => String(v.id) === String(formData[field.name])
                      );
                      return bool ? bool.name : String(formData[field.name]); // fallback
                    })()
                    : formData[field.name]
                }
              >
                {determineField(field)}
              </EditableSection>
            );
          }

          return determineField(field);
        }
      });
  }

  return <>{formData ? generateForm() : 'No form data'}</>;
};
export default FormGenerator;
